<template>
  <div />
</template>
<script>
export default {
  props: {
    interval: Number,
  },
  data () {
    return {
      timer: -1,
      lastExec: 0,
    }
  },
  created () {
    document.addEventListener('visibilitychange', this.onVisibilitychange)
    this.start()
  },
  destroyed () {
    document.removeEventListener('visibilitychange', this.onVisibilitychange)
    this.clear()
  },
  activated () {
    document.addEventListener('visibilitychange', this.onVisibilitychange)
    this.start()
  },
  deactivated () {
    document.removeEventListener('visibilitychange', this.onVisibilitychange)
    this.clear()
  },
  methods: {
    callback () {
      this.lastExec = Date.now()
      this.$emit('exec')
    },
    onVisibilitychange () {
      if (document.visibilityState === 'visible') {
        this.start()
      } else {
        this.clear()
      }
    },
    start () {
      this.clear()
      if (this.lastExec) {
        if (Date.now() - this.lastExec >= this.interval) {
          this.callback()
        }
      } else {
        this.lastExec = Date.now()
      }
      this.timer = setInterval(this.callback, this.interval)
    },
    clear () {
      clearInterval(this.timer)
    }
  }
}
</script>
